import { Document, Page, Text, View, Image, StyleSheet, Font } from "@react-pdf/renderer";
import groupImgFirst from "../../Assets/Images/GroupImgFirst.png";
import groupImgSecond from "../../Assets/Images/GroupImgSecond.png";

const GroupLeadershipFlowSeocnd = () => {

  const styles = StyleSheet.create({
    page: {
      paddingHorizontal: 21,
      paddingVertical: 30,
      backgroundColor: '#FFFFFF',
      justifyContent: "space-between",
      height: '100%'
    },
    header: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      borderBottom: '1px solid #00577D',
      paddingBottom: 5,
      marginBottom: 2,
      marginTop: '-15px'
    },
    titlemain: {
      fontSize: 12,
      fontWeight: 700,
      color: '#76A3BE',
    },
    title: {
      fontSize: 11,
      fontWeight: 200,
      color: '#76A3BE',
    },
    rightsection: {
      alignItems: 'flex-end',
      flexDirection: 'column',
      flex: 1,
    },
    rightText: {
      fontSize: 8,
      textAlign: 'right',
      fontWeight: 700,
      color: '#76A3BE',
    },
    rightTextsybtext: {
      fontSize: 8,
      textAlign: 'right',
      fontWeight: 700,
      color: '#76A3BE',
    },
    section: {
      marginVertical: 10,
    },
    container: {
      marginTop: 20,
      fontFamily: 'Lato',
    },
    headertext: {
      fontSize: 18,
      fontWeight: 700,
      color: '#426B88',
      marginBottom: 20,
      marginTop: 8,
      textAlign: 'center'
    },
    image: {
      width: 297,
      height: 314,
      alignSelf: 'center'
    },
    paragraph: {
      fontSize: 12,
      textAlign: 'justify',
      fontWeight: 400,
      color: '#245775',
      marginBottom: 5,
      fontFamily: 'Lato',
    },
    paragraphtopspace: {
      fontSize: 12,
      textAlign: 'justify',
      fontWeight: 400,
      color: '#245775',
      marginBottom: 5,
      fontFamily: 'Lato',
      marginTop: 12
    },
    footer: {
      width: 540,
      borderTop: '1px solid #00577D',
      paddingTop: 5,
      flexDirection: 'row',
      justifyContent: 'space-between',
      position: 'absolute',
      bottom: 15,
      left: 10,
      right: 21,
    },
    footersection: {
      flexDirection: 'column'
    },
    footerTextheading: {
      fontSize: 10,
      fontWeight: 700,
      fontFamily: 'Lato',
      color: '#76A3BE',
    },
    footerText: {
      fontSize: 8,
      fontFamily: 'Lato',
      fontWeight: 400,
      color: '#76A3BE',
    },
    imageContainer: {
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        gap: "40px", 
        marginTop: "20px",
      },
      imageWrapper: {
        textAlign: "center",
        justifyContent: "center"
      },
      optionTitle: {
        fontWeight: "700",
        fontFamily: "Lato",
        fontSize: "18px",
        color: "#426B88",
        lineHeight: "21px",
        marginLeft: "22%",
        justifyContent: "center",
        alignItems: "center",
        marginBottom: "10px",
      },
      coverImage: {
        width: "205px",
        height: "205px",
        marginBottom: "10px",
      },
      noteContainer: {
       padding: "2% 4% 0 4%",
        alignItems: "center",
         display: "flex",
        justifyContent: "center"
    
      },
      
      noteBold: {
        fontSize: 12,
        fontWeight: 700, 
        fontFamily: "Lato",
        color: "#426B88",
      },
      
      noteText: {
        fontSize: 12,
        fontWeight: 400, 
        color: "#426B88", 
        lineHeight: 2,    
        letterSpacing: 0, 
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center", 
      },
  });

  return (
    <View style={styles.page}>
      <View>
        {/* Header */}
        <View style={styles.header}>
          <View style={styles.headerleft}>
            <Text style={styles.titlemain}>QUADRANT FLOW</Text>
            <Text style={styles.title}>Life & Leadership Assssment</Text>
          </View>
          <View style={styles.rightsection}>
            <Text style={styles.rightText}>Rob Murray</Text>
            <Text style={styles.rightTextsybtext}>
              Atlas Real Estate{"\n"}Oct 18, 2024
            </Text>
          </View>
        </View>

        {/* Image */}
        <View style={styles.container}>
          <Text style={styles.headertext}>GROUP LEADERSHIP FLOW</Text>
        </View>

        <View style={styles.imageContainer}>
          {/* Left Image */}
          <View style={styles.imageWrapper}>
            <Text style={styles.optionTitle}>OPTION 1</Text>
            <Image src={groupImgFirst} style={styles.coverImage} />
          </View>

          {/* Right Image */}
          <View style={styles.imageWrapper}>
            <Text style={styles.optionTitle}>OPTION 2</Text>
            <Image src={groupImgSecond} style={styles.coverImage} />
          </View>
        </View>

        {/* Content */}
        <View style={styles.section}>
          <Text style={styles.paragraph}>
            Quadrant Flow is a leadership framework that focuses on the movement
            of energy across four essential quadrants: Mind, Strength, Heart,
            and Soul.
          </Text>

          <Text style={styles.paragraphtopspace}>
            Each quadrant reflects a different aspect of leadership: the Mind
            drives strategic thinking, Strength fuels performance and action,
            the Heart fosters collaboration and connection, and the Soul
            represents visionary insight.
          </Text>
          <Text style={styles.paragraphtopspace}>
            Unlike rigid personality assessments, Quadrant Flow emphasizes
            fluidity, showing that leadership flows dynamically between these
            quadrants. The areas where we flow last—often perceived as
            weaknesses—are actually opportunities for growth and development.
          </Text>
          <Text style={styles.paragraphtopspace}>
            This holistic approach encourages leaders to see potential in every
            quadrant, deepening self-awareness and fostering balanced, effective
            leadership.
          </Text>
        </View>

        {/* Note Section */}
        <View style={styles.noteContainer}>
          <Text>
            <Text style={styles.noteBold}>Note:</Text>
            <Text style={styles.noteText}>
                {" "}
                Your group exhibits an equal flow between the Collaborative
                and Leadership styles, moving seamlessly in both directions.
            </Text>
          </Text>
        </View>
      </View>

      {/* Footer Section */}
      <View style={styles.footer}>
        <View style={styles.footersection}>
          <Text style={styles.footerTextheading}>SELF REPORT</Text>
          <Text style={styles.footerText}>
            © Copyright 2025 by Dr. Rob Murray & Jack Nicholson. Published by
            Transformational Performance & Transformed Leader. All rights
            reserved.
          </Text>
        </View>
        <Text style={styles.footerTextheading}>PAGE</Text>
      </View>
    </View>
  );
}

export default GroupLeadershipFlowSeocnd;